import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=10f16c60&scoped=true&"
import script from "./buttons.vue?vue&type=script&lang=js&"
export * from "./buttons.vue?vue&type=script&lang=js&"
import style0 from "./buttons.vue?vue&type=style&index=0&id=10f16c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f16c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f16c60')) {
      api.createRecord('10f16c60', component.options)
    } else {
      api.reload('10f16c60', component.options)
    }
    module.hot.accept("./buttons.vue?vue&type=template&id=10f16c60&scoped=true&", function () {
      api.rerender('10f16c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/uikit/buttons.vue"
export default component.exports